import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'

import CostTable from './CostTable'
import Table from './Table'
import Pagination from '@components/Pagination/Pagination'
import Filters from './Filters'
import Spinner from '@components/spinner'

class ExpertHistory extends Component {
  static propTypes = {
    historyStore: PropTypes.object,
    page: PropTypes.number,
    changePage: PropTypes.func
  }

  render () {
    const { historyStore } = this.props
    const firstName = historyStore.expertStore.expert.firstName
    const lastName = historyStore.expertStore.expert.lastName
    return (
      <DocumentTitle
        title={`${firstName} ${lastName} - history | Atheneum Partners`}
      >
        <div className='animate-intro'>
          <Filters changePage={p => this.props.changePage(p)} />
          <h2 className='table-title'>Expert's projects</h2>

          {historyStore.loadingFilteredResults ? (
            <Spinner />
          ) : (
            <div className='animate-intro'>
              <Table />
              <Pagination
                total={historyStore.projects.count}
                perPage={historyStore.perPage}
                page={this.props.page}
                onChange={p => this.props.changePage(p)}
              />
            </div>
          )}

          <h2 className='table-title'>Expert's costs</h2>
          <CostTable />
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('historyStore')(observer(ExpertHistory))
